import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	output,
	ViewEncapsulation,
} from '@angular/core';

import { SvgIconComponent } from 'angular-svg-icon';

import { cn } from '@valk-nx/core/lib/core';

import type { TagColor } from './contracts/tag.types';

export const colorMap: Record<TagColor, string> = {
	accent: 'tag-accent',
	black: 'tag-black',
	blue: 'tag-blue',
	'dark-accent': 'tag-dark-accent',
	'dark-blue': 'tag-dark-blue',
	green: 'tag-green',
	'light-green': 'tag-light-green',
	'light-lime': 'tag-light-lime',
	magenta: 'tag-magenta',
	orange: 'tag-orange',
	primary: 'tag-primary',
	pink: 'tag-pink',
	transparent: 'tag-transparent',
	yellow: 'tag-yellow',
};

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [SvgIconComponent],
	selector: 'vp-tag',
	templateUrl: './tag.html',
})
export class TagComponent {
	clickable = input<boolean>(false);
	color = input<TagColor>('dark-blue');
	iconLeading = input<string | undefined>(undefined);
	iconTrailing = input<string | undefined>(undefined);

	clicked = output<void>();

	colorClass = computed(() => colorMap[this.color()]);

	protected readonly cn = cn;

	onClick() {
		if (this.clickable()) {
			this.clicked.emit();
		}
	}
}
